import {createSelector} from "reselect";

import {getArticleOptionsData, getBaseArticle, getCartItems, getDomainData} from "./SimpleSelectors";
import {getAppMode, isAgencyCustomer} from "./Mode";
import {delve} from "../util/util";
import {APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE} from "../constants/General";
import {cmsArticles, shopArticles} from "../config/Config";

// **************************************************************************************************************
export const getArticleOptionsInCartList = createSelector(
    [getCartItems, getBaseArticle],
    (cartItems, baseArticle) => {
        if (!cartItems) {
            return []
        }
        const articleOptions = cartItems.filter((cartItem) => {
            return (cartItem.itemType !== "DOMAIN") && (cartItem.identifier !== ("" + baseArticle.articleNumber))
        })

        return articleOptions.map((articleOption) => {
            return articleOption.identifier
        })
    }
)

export const getArticleOptionsInCartObject = createSelector(
    [getCartItems, getBaseArticle, getArticleOptionsData],
    (cartItems, baseArticle, articleOptionsData) => {

        if (!cartItems || !articleOptionsData || !baseArticle) {
            return []
        }

        const articleOptions = cartItems.filter((cartItem) => {
            return (cartItem.itemType !== "DOMAIN")
                && (cartItem.identifier !== ("" + baseArticle.articleNumber));
        })

        return articleOptions.map((articleOption) => {

            const articleNumber = articleOption.identifier
            const articleOptionData = articleOptionsData[articleNumber]
            let isSetupFee = true;

            if (!articleOptionData) {
                return {
                    title: "articleOptionData missing",
                    itemId: articleOption.id,
                    setupFee: 0,
                    priceMonthly: 0,
                    contract: {}
                }
            }

            if (getAppMode() === APP_MODE_OUTSOURCING || getAppMode() === APP_MODE_PRODUCT_CHANGE) {
                // actually no setup fee for EK tariffs
                if ([...cmsArticles, ...shopArticles].includes("" + articleNumber)) {
                    isSetupFee = false;
                }
            }

            return {
                title: articleOptionData.title,
                description: articleOptionData.description,
                itemId: articleOption.id,
                articleNumber: articleNumber,
                type: articleOptionData.type,
                billing: articleOptionData.billing,
                contract: articleOptionData.contract,
                setupFee: (isSetupFee && articleOptionData.price && articleOptionData.price.default.setupFee) ? articleOptionData.price.default.setupFee : 0,
                priceMonthly: (articleOptionData.price && articleOptionData.price.default.net) ? articleOptionData.price.default.net : 0,
                inclusiveStorage: (articleOptionData.projectSpace)
            }
        })
    }
)

export const getDomainInCartList = createSelector(
    [getCartItems],
    (cartItems) => {
        if (!cartItems) {
            return []
        }
        const domainItems = cartItems.filter((cartItem) => {
            return cartItem.itemType === "DOMAIN"
        })

        return domainItems.map((domainItem) => {
            return domainItem.identifier
        })
    }
)

export const getDomainInCartObject = createSelector(
    [getCartItems, getDomainData, getBaseArticle, isAgencyCustomer],
    (cartItems, domainData, baseArticle, isAgencyCustomer) => {

        if (!cartItems || Object.keys(domainData).length === 0) {
            return []
        }

        let limit = baseArticle && baseArticle.benefits && baseArticle.benefits.domain && baseArticle.benefits.domain.inclusive


        const domainItems = cartItems.filter((cartItem) => {
            return cartItem.itemType === "DOMAIN"
        })

        return domainItems.map((domainItem) => {

            const split = domainItem.identifier.split(/\.([a-zA-Z.]+)/)
            const domainDataEntry = domainData[split[1]]

            let isInclusiveDomain = false

            if (limit > 0 && domainData[split[1]].isAllowedAsInclusiveDomain !== 0) {
                limit--;
                isInclusiveDomain = true
            }

            const agencyArticle = isAgencyCustomer ? domainDataEntry.agencyArticle : null;
            let setupFee, priceMonthly;

            if (isInclusiveDomain) {
                setupFee = 0;
                priceMonthly = 0;
            } else if (agencyArticle) {
                setupFee = delve(agencyArticle, "price.default.setupFee");
                priceMonthly = delve(agencyArticle, "price.default.net");
            } else {
                setupFee = domainDataEntry.setupFee;
                priceMonthly = domainDataEntry.price;
            }

            return {
                domainName: split[0],
                domainEnding: split[1],
                domain: domainItem.identifier,
                itemId: domainItem.id,
                setupFee,
                priceMonthly,
                isInclusiveDomain
            }
        })
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/CartUtil.js
 **/